import { useState, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { RouteLink } from 'route/components/RouteLink';
import { Tab, Tabs } from 'common/components/Tabs';
import { TTabsMenuItem } from 'common/types';
import { useTrainingRoutes } from 'training/hooks';

interface IProps {
    tabs: TTabsMenuItem[];
}

export const TrainingTabsMenu = ({ tabs }: IProps) => {
    const [_translate, { language }] = useTranslation();
    const [loaded, setLoaded] = useState(!('fonts' in document));
    const { activeSectionRoute } = useTrainingRoutes();

    useLayoutEffect(() => {
        document.fonts.ready.then(() => {
            setLoaded(true);
        });
    }, []);

    return (
        <Tabs
            indicatorColor="primary"
            textColor="primary"
            value={`${loaded}-${language}-${activeSectionRoute}`}
            variant="scrollable"
        >
            {tabs.map((tabItem) => (
                <Tab
                    {...tabItem}
                    component={RouteLink}
                    key={tabItem.value}
                    value={`${loaded}-${language}-${tabItem.value}`}
                />
            ))}
        </Tabs>
    );
};
